import React from 'react';
import ColorfulIcon from './ColorfulIcon';
import { mainServices } from '../mockData';

const iconGradients = ['blue', 'teal', 'purple', 'indigo'];

const MainServices = () => {
  return (
    <section className="py-6 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {mainServices.map((service, index) => {
            return (
              <div
                key={service.id}
                className="group bg-gray-50 hover:bg-white border border-gray-200 rounded-3xl p-8 hover:shadow-lg transition-all duration-300 hover:transform hover:scale-105"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="flex flex-col items-center text-center">
                  <ColorfulIcon 
                    icon={service.icon} 
                    size={32} 
                    gradient={iconGradients[index % iconGradients.length]} 
                  />
                  <h3 className="text-xl font-semibold text-gray-900 mb-2 mt-4" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Display, sans-serif' }}>{service.title}</h3>
                  <p className="text-gray-600 text-sm" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Text, sans-serif' }}>{service.subtitle}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default MainServices;